import React, { useState, useEffect } from "react";
import {
    Box,
    Typography,
    Divider,
    TextField,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Button,
    FormControl,
    InputLabel,
    Select,
    MenuItem
} from "@mui/material";
import { TbCalendarOff } from "react-icons/tb";
import { BiShow } from "react-icons/bi";
import { useOutletContext, useLocation } from "react-router-dom";
import { Pagination } from "@mui/material";

import {
    useGetAllOtherProfitQuery,
    useGetAllConsignedProfitQuery,
    useGetAllServiceProfitQuery,
    useGetOtherProfitByDateMutation,
    useGetConsignedProfitByDateMutation,
    useGetServiceProfitByDateMutation
} from "../../../redux/slices/admin/payment/totalEarningSlince.js";

import "../../../styles/admin.css/payments-css/total-earnings.css";

export default function TotalEarnings() {
    const { sidebarOpen } = useOutletContext();


    const location = useLocation();

    // default
    const [earningType, setEarningType] = useState("Digər üzrə qazanc");

    const [isFromStatBox, setIsFromStatBox] = useState(false);
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [search, setSearch] = useState("");
    const [openRow, setOpenRow] = useState(null);
    const [tableData, setTableData] = useState([]);
    const [page, setPage] = useState(1);
    const itemsPerPage = 50;




    const handleClearDateFilter = () => {
        setStartDate("");
        setEndDate("");
        setSearch("");
        setOpenRow(null);

        if (earningType === "Digər üzrə qazanc") {
            setTableData(
                Array.isArray(otherProfitRes?.data)
                    ? otherProfitRes.data
                    : []
            );
        } else if (earningType === "Yağ üzrə qazanc") {
            setTableData(
                Array.isArray(consignedProfitRes?.data)
                    ? consignedProfitRes.data
                    : []
            );
        } else if (earningType === "Xidmət haqqı") {
            setTableData(
                Array.isArray(serviceProfitRes?.data)
                    ? serviceProfitRes.data
                    : []
            );
        }
    };


    const { data: otherProfitRes, isLoading: isLoadingOther } =
        useGetAllOtherProfitQuery(undefined, {
            skip: earningType !== "Digər üzrə qazanc"
        });

    const { data: consignedProfitRes, isLoading: isLoadingConsigned } =
        useGetAllConsignedProfitQuery(undefined, {
            skip: earningType !== "Yağ üzrə qazanc"
        });

    const { data: serviceProfitRes, isLoading: isLoadingService } =
        useGetAllServiceProfitQuery(undefined, {
            skip: earningType !== "Xidmət haqqı"
        });

    const [getOtherProfitByDate] = useGetOtherProfitByDateMutation();
    const [getConsignedProfitByDate] = useGetConsignedProfitByDateMutation();
    const [getServiceProfitByDate] = useGetServiceProfitByDateMutation();


    useEffect(() => {
        if (location.state?.earningType) {
            setEarningType(location.state.earningType);
            setIsFromStatBox(true);

            window.history.replaceState({}, document.title);
        }
    }, []);


    useEffect(() => {
        if (earningType === "Digər üzrə qazanc") {
            setTableData(
                Array.isArray(otherProfitRes?.data)
                    ? otherProfitRes.data
                    : []
            );
        } else if (earningType === "Yağ üzrə qazanc") {
            setTableData(
                Array.isArray(consignedProfitRes?.data)
                    ? consignedProfitRes.data
                    : []
            );
        } else if (earningType === "Xidmət haqqı") {
            setTableData(
                Array.isArray(serviceProfitRes?.data)
                    ? serviceProfitRes.data
                    : []
            );
        }
    }, [earningType, otherProfitRes, consignedProfitRes, serviceProfitRes]);


    const handleDateChange = async () => {
        if (!startDate || !endDate) return;

        const fromDate = startDate + "T00:00:00";
        const toDate = endDate + "T23:59:59";

        try {
            if (earningType === "Digər üzrə qazanc") {
                const res = await getOtherProfitByDate({ fromDate, toDate }).unwrap();
                setTableData(Array.isArray(res?.data) ? res.data : []);
            } else if (earningType === "Yağ üzrə qazanc") {
                const res = await getConsignedProfitByDate({ fromDate, toDate }).unwrap();
                setTableData(Array.isArray(res?.data) ? res.data : []);
            } else if (earningType === "Xidmət haqqı") {
                const res = await getServiceProfitByDate({ fromDate, toDate }).unwrap();
                setTableData(Array.isArray(res?.data) ? res.data : []);
            }
        } catch {
            setTableData([]);
        }
    };

    const handleEarningTypeChange = (e) => {
        setEarningType(e.target.value);
        setStartDate("");
        setEndDate("");
        setSearch("");
        setOpenRow(null);
    };


    const filteredPayments = Array.isArray(tableData)
        ? tableData.filter((item) => {
            const s = search.toLowerCase();

            if (earningType === "Digər üzrə qazanc") {
                return (
                    item.productName?.toLowerCase().includes(s) ||
                    item.fuelType?.toLowerCase().includes(s)
                );
            } else if (earningType === "Xidmət haqqı") {
                return (
                    String(item.saleId).includes(s) ||
                    (Array.isArray(item.itemDtos) &&
                        item.itemDtos.some(i =>
                            i.serviceName?.toLowerCase().includes(s)
                        ))
                );
            }

            return (
                item.companyName?.toLowerCase().includes(s) ||
                (Array.isArray(item.productDtos) &&
                    item.productDtos.some(p =>
                        p.productName?.toLowerCase().includes(s)
                    ))
            );
        })
        : [];

    const totalProfitSum = filteredPayments.reduce((acc, item) => {
        if (earningType === "Digər üzrə qazanc") {
            return acc + (Number(item.profit) || 0);
        } else if (earningType === "Yağ üzrə qazanc") {
            return acc + (Number(item.totalProfit) || 0);
        } else if (earningType === "Xidmət haqqı") {
            return acc + (Number(item.totalServiceFee) || 0);
        }
        return acc;
    }, 0);

    // SAYFALAMA BURADA YAPILIYOR
    const totalPages = Math.ceil(filteredPayments.length / itemsPerPage);
    const startIndex = (page - 1) * itemsPerPage;
    const paginatedEarnings = filteredPayments.slice(startIndex, startIndex + itemsPerPage);
    const handleShowClick = (id) => {
        setOpenRow(openRow === id ? null : id);
    };

    useEffect(() => {
        setPage(1);
    }, [earningType, search]);

    return (
        <Box className={`total-earnings-container ${sidebarOpen ? "sidebar-open" : ""}`}>
            <Box className="total-earnings-header">
                <Box className="total-earnings-title">
                    <Typography style={{ color: "#545A61" }}>
                        Ümumi Qazanclar
                    </Typography>
                    <Divider className="total-earnings-divider" />
                </Box>

                <Box className="filters-row">
                    <Box style={{ display: "flex", gap: 15, flexWrap: "wrap" }}>
                        <Box
                            sx={{
                                width: 40,
                                height: 40,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                border: "1px solid rgba(0,0,0,0.23)",
                                borderRadius: "4px",
                                cursor: "pointer",
                                "&:hover": {
                                    backgroundColor: "rgba(0,0,0,0.04)"
                                }
                            }}
                            onClick={handleClearDateFilter}
                        >
                            <TbCalendarOff size={18} />
                        </Box>


                        <TextField
                            size="small"
                            type="date"
                            label="Tarixdən"
                            InputLabelProps={{ shrink: true }}
                            value={startDate}
                            onChange={(e) => setStartDate(e.target.value)}
                            style={{ minWidth: 160 }}
                        />

                        <TextField
                            size="small"
                            type="date"
                            label="Tarixə"
                            InputLabelProps={{ shrink: true }}
                            value={endDate}
                            onChange={(e) => setEndDate(e.target.value)}
                            onBlur={handleDateChange}
                            style={{ minWidth: 160 }}
                        />


                        <FormControl size="small" style={{ minWidth: 180 }}>
                            <InputLabel>Qazanc Növü</InputLabel>
                            <Select
                                value={earningType}
                                label="Qazanc Növü"
                                onChange={handleEarningTypeChange}
                            >
                                <MenuItem value="Digər üzrə qazanc">Digər üzrə qazanc</MenuItem>
                                <MenuItem value="Yağ üzrə qazanc">Yağ üzrə qazanc</MenuItem>
                                <MenuItem value="Xidmət haqqı">Xidmət haqqı</MenuItem>
                            </Select>
                        </FormControl>


                    </Box>
                    <TextField
                        size="small"
                        placeholder={earningType === "Xidmət haqqı" ? "Satış №..." : "Axtar..."}
                        className="total-earnings-search"
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                    />
                </Box>

                <Box sx={{
                    mt: 2,
                    mb: -1
                }}>
                    <Box sx={{
                        backgroundColor: "#f8f9fa",
                        padding: "10px 20px",
                        borderRadius: "0",
                        borderLeft: "5px solid #2e7d32",
                        boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        width: "100%"
                    }}>
                        <Typography sx={{ color: "#545A61", fontWeight: "600", fontSize: "0.9rem" }}>
                            SEÇİLMİŞ NÖV ÜZRƏ YEKUN QAZANC:
                        </Typography>
                        <Typography variant="h5" sx={{ color: "#2e7d32", fontWeight: "bold" }}>
                            {totalProfitSum.toFixed(2)} ₼
                        </Typography>
                    </Box>
                </Box>
            </Box>

            <TableContainer component={Paper} className="total-earnings-table">
                <Table>
                    <TableHead>
                        <TableRow>
                            {earningType === "Digər üzrə qazanc" ? (
                                <>
                                    <TableCell><strong>#No</strong></TableCell>
                                    <TableCell><strong>Məhsul</strong></TableCell>
                                    <TableCell><strong>Miqdar</strong></TableCell>
                                    <TableCell><strong>Maya</strong></TableCell>
                                    <TableCell><strong>Yanacaq</strong></TableCell>
                                    <TableCell><strong>Dövriyyə</strong></TableCell>
                                    <TableCell><strong>Qazanc</strong></TableCell>
                                </>
                            ) : earningType === "Xidmət haqqı" ? (
                                <>
                                    <TableCell><strong>Satış №</strong></TableCell>
                                    <TableCell><strong>Ümumi Məbləğ</strong></TableCell>
                                    <TableCell><strong>Seçim</strong></TableCell>
                                </>
                            ) : (
                                <>
                                    <TableCell><strong>#No</strong></TableCell>
                                    <TableCell><strong>Şirkət</strong></TableCell>
                                    <TableCell><strong>Ümumi Qazanc</strong></TableCell>
                                    <TableCell><strong>Seçim</strong></TableCell>
                                </>
                            )}
                        </TableRow>
                    </TableHead>

                    <TableBody>
                        {(earningType === "Digər üzrə qazanc" ? isLoadingOther : earningType === "Xidmət haqqı" ? isLoadingService : isLoadingConsigned) ? (
                            <TableRow>
                                <TableCell colSpan={8} align="center">Yüklənir...</TableCell>
                            </TableRow>
                        ) : paginatedEarnings.length === 0 ? (
                            <TableRow>
                                <TableCell colSpan={8} align="center">Məlumat tapılmadı</TableCell>
                            </TableRow>
                        ) : (
                            paginatedEarnings.map((emp, index) => (
                                <React.Fragment key={index}>
                                    {earningType === "Digər üzrə qazanc" ? (
                                        <TableRow>
                                            <TableCell>{"#" + String(emp.productId).padStart(4, "0")}</TableCell>
                                            <TableCell>{emp.productName}</TableCell>
                                            <TableCell>{emp.soldQuantity}</TableCell>
                                            <TableCell>{emp.costPrice}₼</TableCell>
                                            <TableCell>{emp.fuelType ? emp.fuelType : "-"}</TableCell>
                                            <TableCell>{emp.circulation}₼</TableCell>
                                            <TableCell>{emp.profit}₼</TableCell>
                                        </TableRow>
                                    ) : earningType === "Xidmət haqqı" ? (
                                        <TableRow>
                                            <TableCell>{"#" + String(emp.saleId).padStart(4, "0")}</TableCell>
                                            <TableCell>{emp.totalServiceFee}₼</TableCell>
                                            <TableCell className="manage-wrapper">
                                                <Button
                                                    size="small"
                                                    variant="contained"
                                                    className="total-earnings-btn"
                                                    onClick={() => handleShowClick(emp.saleId)}
                                                >
                                                    <BiShow style={{ width: "24px", height: "24px" }} />
                                                </Button>
                                            </TableCell>
                                        </TableRow>
                                    ) : (
                                        <TableRow>
                                            <TableCell>{"#" + String(emp.companyId).padStart(4, "0")}</TableCell>
                                            <TableCell>{emp.companyName}</TableCell>
                                            <TableCell>{emp.totalProfit}₼</TableCell>
                                            <TableCell className="manage-wrapper">
                                                <Button
                                                    size="small"
                                                    variant="contained"
                                                    className="total-earnings-btn"
                                                    onClick={() => handleShowClick(emp.companyId)}
                                                >
                                                    <BiShow style={{ width: "24px", height: "24px" }} />
                                                </Button>
                                            </TableCell>
                                        </TableRow>
                                    )}

                                    {earningType === "Xidmət haqqı" &&
                                        openRow === emp.saleId &&
                                        Array.isArray(emp.itemDtos) && (
                                            <TableRow>
                                                <TableCell colSpan={3} className="total-earnings-expanded-cell">
                                                    <Table size="small" className="payment-table">
                                                        <TableHead>
                                                            <TableRow>
                                                                <TableCell><strong>Xidmət adı</strong></TableCell>
                                                                <TableCell><strong>Məbləğ</strong></TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {emp.itemDtos.map((p, i) => (
                                                                <TableRow key={i}>
                                                                    <TableCell>{p.serviceName}</TableCell>
                                                                    <TableCell>{p.serviceFee}₼</TableCell>
                                                                </TableRow>
                                                            ))}
                                                        </TableBody>
                                                    </Table>
                                                </TableCell>
                                            </TableRow>
                                        )}

                                    {earningType === "Yağ üzrə qazanc" &&
                                        openRow === emp.companyId &&
                                        Array.isArray(emp.productDtos) && (
                                            <TableRow>
                                                <TableCell colSpan={4} className="total-earnings-expanded-cell">
                                                    <Table size="small" className="payment-table">
                                                        <TableHead>
                                                            <TableRow>
                                                                <TableCell><strong>Məhsul</strong></TableCell>
                                                                <TableCell><strong>Miqdar</strong></TableCell>
                                                                <TableCell><strong>Dövriyyə</strong></TableCell>
                                                                <TableCell><strong>Qazanc</strong></TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {emp.productDtos.map((p, i) => (
                                                                <TableRow key={i}>
                                                                    <TableCell>{p.productName}</TableCell>
                                                                    <TableCell>{p.soldQuantity}</TableCell>
                                                                    <TableCell>{p.circulation}₼</TableCell>
                                                                    <TableCell>{p.profit}₼</TableCell>
                                                                </TableRow>
                                                            ))}
                                                        </TableBody>
                                                    </Table>
                                                </TableCell>
                                            </TableRow>
                                        )}
                                </React.Fragment>
                            ))
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
            {filteredPayments.length > itemsPerPage && (
                <Box sx={{ display: 'flex', justifyContent: 'right', p: 3, mt: 2 }}>
                    <Pagination
                        count={totalPages}
                        page={page}
                        onChange={(e, value) => {
                            setPage(value);
                            window.scrollTo({ top: 0, behavior: 'smooth' });
                        }}
                        color="primary"
                        variant="outlined"
                        shape="rounded"
                    />
                </Box>
            )}
        </Box>
    );
}
